// Очередь запросов, сделанных офлайн (жалобы, согласия): отправляются при выходе в сеть с тем же Idempotency-Key.
import { ApiError, OfflineError, type Api } from "./api.ts";
import type { BrovkaDB } from "./db.ts";
import { uuidv7 } from "./uuid.ts";

export type PendingRequest = { method: "POST"; path: string; body: unknown; key: string };

export async function enqueue(db: BrovkaDB, path: string, body: unknown): Promise<string> {
  const key = uuidv7();
  const list = (await db.get<PendingRequest[]>("pending")) ?? [];
  await db.set("pending", [...list, { method: "POST", path, body, key }]);
  return key;
}

/** Отправить очередь; возвращает ключи, которые остались неотправленными. */
export async function flush(api: Api, db: BrovkaDB): Promise<Set<string>> {
  const list = (await db.get<PendingRequest[]>("pending")) ?? [];
  const left: PendingRequest[] = [];
  for (const p of list) {
    try {
      await api.ensureDevice();
      await api.request(p.method, p.path, p.body, { idempotencyKey: p.key });
    } catch (e) {
      // Ошибки данных (400/409) не повторяем — иначе очередь застрянет навсегда.
      if (e instanceof OfflineError || (e instanceof ApiError && (e.status === 429 || e.status === 401))) left.push(p);
    }
  }
  await db.set("pending", left);
  return new Set(left.map((p) => p.key));
}
